import EscovacaoSupervisionadaIcon from '@/components/icons/IndicadoresEsb/Estrategicos/EscovacaoSupervisionada.vue'

export default {
  value: 'b4',
  label: 'Escovação supervisionada',
  iconType: 'component',
  iconComponent: EscovacaoSupervisionadaIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: 'Pessoa sem realização de escovação supervisionada.',
  },
}
